<pp-button class="savedViews__button" ppStyle="primary" ppSize="small" (ppAction)="hideDropdown()">
  {{ 'done' | ppTranslate }}
</pp-button>
